// 机场镜头  页面
import React, { useEffect, useRef, useState } from 'react'
import { Spin, Card, Button, Radio, Dropdown, theme, App } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { getAirLiveAddress, pushFlowLiveAPI, getAirport, flowLiveUpdateAPI, getImplementingPipelineNameAPI } from '@/server/airportCamera'
import warning from '@/common/img/video/warning.svg';
import airportWarning from '@/common/img/video/airportWarning.svg';
import VideoPatrolMonitor from './video_patrol_monitor.js'
import DemoCopy from './command_flight.js'
import LiveVideo from '@/component/LiveVideo/index.js'
import FlvVideo from '@/component/FlvVideo/index.js'
import { debounce } from '@/common/js/common.js'
import { getWebSocketAddress } from '@/server/commandFlight.js'
// import "./index.css"
import dayjs from 'dayjs';


function AirportCamera (props) {
  const { message } = App.useApp();

  const liveUrl = useRef('')
  const [liveUrlState, setLiveUrlState] = useState('')//直播地址
  const [videoId, setVideoId] = useState('')//直播id
  const {
    token: { colorTextTertiary, colorTextQuaternary },
  } = theme.useToken(); //获取主题颜色

  const ws = useRef()//ws
  const getWsDataRef = useRef(false)//是否获取到了ws中对应信息
  const [getWsData, setGetWsData] = useState(false)
  const updataInterval = useRef()//机场 updata
  const pipelineNameInterval = useRef()//获取管线名称

  const timer = useRef()//读秒计时器
  const timeNum = useRef(0)//计时容器
  const timer1 = useRef()

  const cycle = useRef(0)//鼠标未动 周期
  const [timeNumber, setTimeNumber] = useState(0)//鼠标多少秒未动了
  const openInfoRef = useRef(0)//打开直播节流提示
  const [openInfo, setOpenInfo] = useState(0)
  const hasMouseStopLive = useRef(false)//鼠标是否动了

  const hasAircraftDataRef = useRef({
    getData: false,//是否获取到数据
    time: 0//获取到数据的时间
  })//是否从ws中获取到无人机信息

  const token = localStorage.getItem('dock_token');
  const [loadingAll, setLoadingAll] = useState(true);//全局loading
  const [videoType, setVideoType] = useState(1);//1机场  3 镜头  4 监控  5指令飞行
  const videoTypeRef = useRef(1)//标签
  const [videoTypeGather, setVideoTypeGather] = useState([]);//视频类型集合
  const [height, setHeight] = useState(0);

  const [dropdownName, setDropdownName] = useState('');//下拉菜单名称
  const [dropdownValue, setDropdownValue] = useState('');//下拉菜单值
  const dropdownValueRef = useRef('');
  const [dropdownItem, setDropdownItem] = useState([]);//下拉菜单选项 - 机场
  const [monitorRefresh, setMonitorRefresh] = useState(true);//机场监控 刷新
  const [curDockPipelineName, setCurDockPipelineName] = useState('')//当前机场管线名称

  //单选改变执行
  const RadioChange = async (e) => {
    setLiveUrlState('')
    liveUrl.current = ''
    let type = e.target.value;
    setVideoType(type);
    videoTypeRef.current = type


    if (ws.current && type !== 3) {
      console.log('销毁ws');
      ws.current.close()
      ws.current = null
      clearInterval(timer1.current)
      timer1.current = null
    }

    if (type === 3) {
      getDockStateByWs(dropdownItem.find(e => e.value === Number(dropdownValueRef.current)))
    } else {
      if (type !== 4) {
        setLoadingAll(true)
        setTimeout(() => {
          liveAddress(type)
        }, 500);
      }
    }
  }

  const resizeUpdate = () => {
    let d = document.getElementById('main').offsetHeight;
    setHeight(d)
  }

  // 直播组件回调
  const returnData = debounce((data) => {
    if (data.canPushFlow) {
      // let aaa = 'https://media.w3.org/2010/05/sintel/trailer.mp4'
      pushFlow()
    }
    if (!data.isLeave && data.isLivePlay) {//判断直播已经开启
      cycle.current = 0
      updataLive()
    } else {
      clearInterval(timer.current)
      timer.current = null
    }
    if (data.isRefresh) { liveAddress(videoType) }
  }, 2000)

  const timingAlgorithm = () => {//计算  计时算法
    timeNum.current = 0
    hasMouseStopLive.current = false

    clearInterval(timer.current)
    timeNum.current = null
    timer.current = setInterval(() => {
      timeNum.current += 1
      let aaa = cycle.current
      let bbb = timeNum.current
      if (hasMouseStopLive.current) {
        openInfoRef.current = 0
        setOpenInfo(0)
        if (timeNum.current === 20) { updataLive() }
      } else {
        if (timeNum.current >= 20) {//计算多少秒为一个周期
          cycle.current += 1
          timingAlgorithm()
        }

        if (cycle.current === 13) {//计算几个周期 弹出警示框
          openInfoRef.current = hasMouseStopLive.current ? 0 : 1
          setOpenInfo(openInfoRef.current)
          setTimeNumber(timeNum.current)
        } else {
          openInfoRef.current = 0
          setOpenInfo(0)
        }

        if (cycle.current > 13) {
          openInfoRef.current = 2
          setOpenInfo(2)
          setLiveUrlState('')
          return
        }//退出循环
      }
    }, 1000)
  }

  const handleMouseMove = debounce((event) => {// 定义处理鼠标移动的函数
    hasMouseStopLive.current = true
    openInfoRef.current = 0
    setOpenInfo(0)
    // 在这里执行你想要的操作，比如更新状态或调用函数
  }, 500)

  const updataLive = async () => {//更新直播
    let res = await flowLiveUpdateAPI({
      access_token: token,
      video_id: videoId
    })
    if (res.ret !== 200) { message.warning(res.msg || '更新失败'); setLoadingAll(false); return }
    cycle.current = 0
    hasMouseStopLive.current = false
    timingAlgorithm()
  }

  // 直播推流
  const pushFlow = async () => {
    liveUrl.current = ''
    setLiveUrlState('')
    setLoadingAll(true)
    let obj = {
      access_token: token,
      camera: videoType === 1 ? `dock` : videoType === 2 ? `fpv` : `cam`,
      videoQuality: 0,
      dock_id: dropdownValue,//当前机场id
    }
    let res = await pushFlowLiveAPI(obj)
    if (res.ret !== 200) { message.warning(res.msg || '推流失败'); setLoadingAll(false); return }
    setTimeout(() => {
      setLoadingAll(false);
      liveUrl.current = res.data?.flv
      setLiveUrlState(res.data?.flv)
      // setLiveUrlState('https://media.w3.org/2010/05/sintel/trailer.mp4')
      setVideoId(res.data.video_id)
    }, 2000);
  }

  const getPipelineName = async (dockId = '') => {//获取执行的航线名称
    let res = await getImplementingPipelineNameAPI({
      access_token: token,
      dock_id: dockId ? dockId : dropdownValue,//当前机场id
    })
    if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了'); return }
    setCurDockPipelineName(res.data ? res.data : '')
  }

  //获取直播地址
  const liveAddress = async (type) => {
    clearInterval(pipelineNameInterval.current)
    getPipelineName(dropdownValueRef.current)
    pipelineNameInterval.current = null
    pipelineNameInterval.current = setInterval(() => {
      getPipelineName(dropdownValueRef.current)
    }, 30000);

    setLiveUrlState('')
    liveUrl.current = ''
    setLoadingAll(true)
    let obj = {
      access_token: token,
      camera: type === 1 ? `dock` : type === 2 ? `fpv` : `cam`,
      dock_id: dropdownValueRef.current ? dropdownValueRef.current : dropdownValue,//当前机场id
    }
    let res = await getAirLiveAddress(obj);
    if (res.ret !== 200) {
      setLoadingAll(false)
      return
    }

    setLoadingAll(false)
    liveUrl.current = res.data?.flv || ''
    setLiveUrlState(res.data?.flv || '')
    setVideoId(res.data.video_id)
  }

  //下拉选择
  const chooseDropdown = (info) => {
    setLoadingAll(true)
    setTimeout(() => {
      setLoadingAll(false)
    }, 1000);
    if (ws.current) {
      ws.current.close()
      console.log('销毁ws');
      ws.current = null
      clearInterval(timer1.current)
      timer1.current = null
    }
    setDropdownValue(info.value);
    dropdownValueRef.current = info.value;
    setDropdownName(info.name);
    let shot = info.shot.map((item) => { return item.value });
    let type = videoType;
    if (shot.indexOf(videoType) < 0) { //说明切换的机场不存在当前类型
      type = shot[0]
      setVideoType(shot[0]);
      videoTypeRef.current = shot[0]
    }
    setVideoTypeGather(info.shot);

    if (type !== 4 && type !== 999) {
      if (type === 3) {
        getDockStateByWs(info)
      } else {
        liveAddress(type)
      }
    } else {
      setMonitorRefresh(false);
      setTimeout(() => {
        setMonitorRefresh(true);
      }, 600);
    }


  }

  //获取机场
  const getAirportFun = async () => {
    let res = await getAirport({
      access_token: token,
    });
    if (res.ret !== 200) {
      message.warning(res.msg || '数据跑丢了~');
      return;
    }
    let arr = res.data.length > 0
      ? res.data.map((item) => {
        let shot = [];
        for (let i = 0; i < item.shot_type.length; i++) {
          let val = item.shot_type[i];
          if (val.value) {
            shot.push({ text: val.text, value: Number(val.value) });
          }
        }

        if (localStorage.getItem('dock_AirportPermissionsArr').indexOf(166) > -1) {
          shot.push({
            text: '指令飞行',
            value: 999
          })
        }
        return {
          name: item.name,
          value: item.id,
          shot: shot,
          aircraftSn: item.aircraftSn,
          dockSn: item.dockSn,
        }
      })
      : [];
    setDropdownItem(arr);
    setVideoTypeGather(arr.length > 0 ? arr[0].shot : [])
    setDropdownName(arr.length > 0 ? arr[0].name : '');
    setDropdownValue(arr.length > 0 ? arr[0].value : '');
    dropdownValueRef.current = arr.length > 0 ? arr[0].value : '';

    if (videoType === 3) { getDockStateByWs(arr[0]) } else { liveAddress(videoType); }

  }

  const getDockStateByWs = async (dockListArr) => {//获取ws信息并写入dataList中
    let res = await getWebSocketAddress({ access_token: token, type: 1 })
    if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了！'); return }

    if (res.ret === 200) {
      ws.current = new WebSocket(res.data);

      ws.current.onopen = (msg) => {//链接开启
        console.log("链接成功", msg);
      };

      ws.current.onmessage = e => {// 成功获取数据
        let data = JSON.parse(e.data)
        if ((videoTypeRef.current === 3 && dockListArr.aircraftSn === data.data.sn)) {//无人机信息
          console.log('dockListArr.name', videoTypeRef.current, dockListArr);
          getWsDataRef.current = true
          setGetWsData(true)
          hasAircraftDataRef.current = {
            getData: true,
            time: dayjs().valueOf()
          }
        }
      }

      ws.current.onerror = (msg) => {//报错信息
        // console.log('链接出错', msg)
        // message.warning('当前ws链接网络不佳，请稍后再试···')
      }

      //链接断开
      ws.current.onclose = (msg) => {
        liveUrl.current = ''
        setLiveUrlState('')
        getWsDataRef.current = false
        setGetWsData(false)
        hasAircraftDataRef.current = {
          getData: false,
          time: dayjs().valueOf()
        }
      }


      let ddd = setInterval(() => {
        if (hasAircraftDataRef.current.getData) {
          liveAddress(videoTypeRef.current)
          clearInterval(ddd)
        }
      }, 1000);

      timer1.current = setInterval(() => {
        if ((dayjs().valueOf() - hasAircraftDataRef.current.time) > (5 * 1000)) {
          liveUrl.current = ''
          setLiveUrlState('')
          getWsDataRef.current = false
          setGetWsData(false)
          hasAircraftDataRef.current = {
            getData: false,//是否获取到数据
            time: 0//获取到数据的时间
          }
        }
      }, 5000)
    } else {
      message.warning(res.msg || '系统出错啦，请稍后重试！')
    }
  }

  useEffect(() => {//监听 页面中是否移动鼠标
    // 添加鼠标移动监听器
    window.addEventListener('mousemove', handleMouseMove);

    // 组件卸载时，移除监听器
    return () => {
      clearInterval(timer.current)
      timer.current = null
      window.removeEventListener('mousemove', handleMouseMove);
    };

    // eslint-disable-next-line
  }, [videoType]); // 空依赖数组表示这个effect只在组件挂载和卸载时运行


  useEffect(() => {
    setLoadingAll(true);
    getAirportFun();
    return () => {
      // EndVideoFun();
      // 组件销毁时移除监听事件
      window.removeEventListener('resize', resizeUpdate);
      clearInterval(pipelineNameInterval.current)
      pipelineNameInterval.current = null
      clearInterval(timer1.current)
      timer1.current = null


      if (ws.current) {
        ws.current.close()
        console.log('销毁ws');
        ws.current = null
        clearInterval(timer1.current)
        timer1.current = null
      }

    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    let d = document.getElementById('main').offsetHeight - 48;
    setHeight(d)
    // eslint-disable-next-line
  }, [height])

  return (
    <div className="hei100 hidden" id='main'>
      {/* height: height + 'px', */}
      <Card
        style={{ border: 0 }} className="mar24"
        styles={{ body: { padding: 0, height: 'calc(100vh - 96px)' } }}
      >
        <>{/* main */}
          <div className="pdRL24 flex_col">
            {/* 头部 */}
            <div className="pdTB16 pdRL8 flex jcsb">
              <div className='flex jcc align_center'>
                <Dropdown
                  trigger={['click']}
                  menu={{
                    items: dropdownItem.map((item, idx) => {
                      return {
                        label: <div onClick={() => { chooseDropdown(item) }}>{item.name}</div>,
                        value: item.value,
                        key: idx,
                      };
                    }),
                  }}
                >
                  <div className='pointer' style={{ display: dropdownItem.length > 0 ? '' : 'none' }}>
                    <span className='marR4'>{dropdownName}</span>
                    <DownOutlined className='fs10' style={{ color: colorTextTertiary }} />
                  </div>
                </Dropdown>

                {/* 当前飞行航线名称 */}
                <div className='marL16'>
                  {
                    curDockPipelineName
                      ? curDockPipelineName
                      : <span style={{ color: colorTextQuaternary }}>-</span>
                  }
                </div>
              </div>

              {/* 右上角类型 */}
              <Radio.Group value={videoType} buttonStyle="solid" onChange={RadioChange}>
                {videoTypeGather.length > 0 && videoTypeGather.map((item, idx) => { return <Radio.Button value={item.value} key={idx}>{item.text}</Radio.Button> })}
              </Radio.Group>
            </div>

            {/* 主体 */}
            <div className='pos_rel' style={{ height: "calc(100vh - 186px)" }}>
              {/* 机场||镜头  直播 */}
              <>
                {
                  (videoType === 1 || videoType === 3) && !loadingAll &&
                  <div
                    className="flex_auto marB24"
                    style={{
                      height: 'calc(100vh - 184px)',
                      display: (videoType === 1 || videoType === 3) && !loadingAll ? `` : `none`
                    }}
                  >
                    {
                      liveUrl.current//是否存在直播地址
                        ? (
                          <FlvVideo
                            type={videoType}
                            liveUrl={liveUrl.current}
                            liveVideoReturn={returnData}
                          />
                        )
                        : (
                          <div className='wid100 hei100 flex_col jcc align_center'>
                            <>{/* 警告图标 */}
                              <img
                                src={warning}
                                alt='警告'
                                className='w80 h80'
                              />
                            </>

                            <>{/* 错误主体文字 */}
                              <div className='col_main_text fs24 opa88'>
                                直播暂未开启
                              </div>
                            </>

                            <>{/* 开启推流 */}
                              {
                                (videoTypeRef.current === 1 || getWsData) &&
                                <Button
                                  className='marT24'
                                  id='startVideo'
                                  type='primary'
                                  onClick={() => { pushFlow() }}
                                >
                                  开启并观看
                                </Button>
                              }
                            </>
                          </div>
                        )
                    }

                  </div>
                }

              </>
              {/* 机场监控 */}
              <>
                {
                  videoType === 4 && monitorRefresh && (
                    <div className="flex_auto marB24 radius8 hidden" style={{ height: 'calc(100vh - 184px)' }}>
                      <VideoPatrolMonitor dockId={dropdownValue} videoTypes={videoTypeGather} />
                    </div>
                  )
                }
              </>

              {/* 指令飞行 */}
              <>
                {
                  videoType === 999 && monitorRefresh && (
                    <div className="flex_auto marB24 radius8 hidden" style={{ height: 'calc(100vh - 184px)' }}>
                      <DemoCopy dockId={dropdownValue} videoTypes={videoTypeGather} />
                    </div>
                  )
                }
              </>

              <>{/* 节流提示 */}
                <>{/* 直播剩余时长  提示 */}
                  {openInfo === 1 &&
                    <div className='pos_abs flex jcl align_center h40 wid100 pdRL16 opa85' style={{ top: 0, left: 0, backgroundColor: 'rgba(0,0,0,0.35)' }} >
                      {`监测到屏幕已有 5 分钟无任何操作，如果你还在观看请动动鼠标，否则 ${(20 - timeNumber)} 秒后将会关闭该直播，以节省网络资源。`}
                    </div>
                  }

                </>
                <>
                  {
                    openInfo === 2 &&
                    <div className='pos_abs flex jcl align_center h40 wid100 pdRL16 opa85' style={{ top: 0, left: 0, backgroundColor: 'rgba(0,0,0,0.35)' }} >
                      {`因长时间无任何操作，已关闭该直播`}
                    </div>
                  }
                </>
              </>

            </div>
          </div>
        </>

        <>{/* 组件集 */}
          <>{/* 全局loading */}
            <div className='pos_abs flex jcc align_center'
              style={{
                bottom: '24px',
                left: '24px',
                height: 'calc(100% - 88px)',
                width: 'calc(100% - 48px)',
                pointerEvents: 'none'
              }}
            >
              {
                (videoType !== 999 && videoType !== 4) &&
                <Spin spinning={loadingAll} size="large" />
              }

            </div>
          </>
        </>

      </Card>
    </div>
  )
}
export default AirportCamera